import type { IconProps } from "../types";

export const Server = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <rect width="20" height="8" x="2" y="2" />
    <rect width="20" height="8" x="2" y="14" />
    <rect x="5" y="5" width="2" height="2" fill="currentColor" stroke="none" />
    <rect x="5" y="17" width="2" height="2" fill="currentColor" stroke="none" />
  </svg>
);
